import { Component, ElementRef, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PaymentCardListComponent } from './tarjeta-credito/paymentcard-list.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { HttpClient } from "@angular/common/http";
import { PaymentCardService } from './paymentcard.service';
import { PaymentCardTypes } from './paymentcard.model';

@Component({
    selector: 'convfact-paymentcarddelete',
    templateUrl: './paymentcard-dialog-delete.component.html',
    styleUrls: ['./paymentcard.component.css'],
    standalone: false
})
export class PaymentCardDialogDeleteComponent {
  uid: string = this.data.uid;
  type: string = this.data.type;
  error_msg: string;
  error: boolean = false;

  private paymentCardType: number = this.data.paymentCardType;

  constructor(
    public dialogRef: MatDialogRef<PaymentCardListComponent>,
    private elementRef: ElementRef,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpClient,
    public snackBar: MatSnackBar,
    public paymentCardService: PaymentCardService)
  { }

  delete() {
    this.paymentCardService.deleteData(this.uid)
      .then(response => { this.dialogRef.close(true); })
      .catch(error => { });
    this.error = true;
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
